import React, { useContext, useRef, useEffect } from 'react';
import TriggerContext from '../TriggerContext';

export const TriggerKnob = ({ id, isOpen = false, children }) => {
  const { addTrigger, getTrigger } = useContext(TriggerContext);
  const elementRef = useRef(null);

  useEffect(() => {
    const removeTrigger = addTrigger(id, {
      anchor: elementRef.current,
      isOpen,
    });

    return () => {
      if (removeTrigger) {
        removeTrigger();
      }
    };
  }, [id, isOpen, addTrigger]);

  const getKnobTrigger = () => {
    const trigger = getTrigger(id);
    if (elementRef.current) {
      return {
        ...trigger,
        isOpen: trigger.isOpen && trigger.anchor === elementRef.current,
        open: trigger.open(elementRef.current),
        toggle: trigger.toggle(elementRef.current),
      };
    } else {
      return {
        isOpen: trigger.isOpen,
      };
    }
  };

  const knobTrigger = getKnobTrigger();
  return <div ref={elementRef}>{children(knobTrigger)}</div>;
};

TriggerKnob.displayName = 'TriggerKnob';
